import isSearchSessionActive from '../selectors/isSearchSessionActive';
import getScenarioStore from '../store/getScenarioStore';
import { getGuid } from 'owa-guid';
import { SearchScenarioId } from 'owa-search-next-common';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('initializeSearchSessionIds', (scenarioId: SearchScenarioId) => {
    // If session is already active, then return.
    if (isSearchSessionActive(scenarioId)) {
        return;
    }

    const store = getScenarioStore(scenarioId);
    store.searchSessionGuid = getGuid();
    store.nextSearchQueryId = getGuid();
});
